export default __webpack_public_path__ + "static/media/cryptoss.3e4c531e.png";